import { Component, OnInit, Input } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
  useAnimation,
} from '@angular/animations';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cq24',
  templateUrl: './cq24.component.html',
  styleUrls: [
    './cq24.component.css',
    '../commercial-questionnaire.component.css',
  ],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
  ],
})
export class Cq24Component implements OnInit {
  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  deviceWidth;
  question_sub1;
  question_sub2;
  promo_code;
  timer;
  disablebutton = false;
  referrals = [
    'Google',
    'Yahoo',
    'Facebook',
    'Instagram',
    'Twitter',
    'Real estate agent',
    'Leasing agent',
    'Apartment community',
    'Postcard flyer',
    'Yelp',
    'Email marketing',
    'Friend',
    'Word of mouth',
    'Other',
    'None of the above',
  ];
  hg_refer;
  time = 3000;

  constructor(
    private commercialService: CommercialService,
    private router: Router
  ) {
    this.questions = this.commercialService.getQues();
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.deviceWidth = this.commercialService.deviceWidth;
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        this.index = i;
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('us?');
          this.question_sub1 = question_sub1[0] + 'us?';
          this.question_sub2 = question_sub1[1];
        }
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        com_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        if (!_.isEmpty(obj.fieldValue.hear_by)) {
          this.hg_refer = obj.fieldValue.hear_by;
        }
        if (!_.isEmpty(obj.fieldValue.promo_code)) {
          this.promo_code = obj.fieldValue.promo_code;
        }
        this.disablebutton = true;
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.getPromoCode();
        }
      }
    }
  }

  getReferrals(event) {
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
    }
    this.hg_refer = event;
    this.user_bot = true;
    this.disablebutton = true;
    if (this.deviceWidth < 768) {
      this.goNext();
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.getPromoCode();
      }, this.time);
    }
  }

  enableButton(event) {
    if (_.isEmpty(this.promo_code) && _.isEmpty(this.hg_refer)) {
      this.disablebutton = false;
    } else {
      this.disablebutton = true;
    }
  }

  getPromoCode() {
    if (_.isEmpty(this.promo_code) && _.isEmpty(this.hg_refer)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({ currentId: this.data });
      }
    } else {
      const Obj = {
        com_question_id: this.data,
        fieldName: 'referral',
        fieldValue: { hear_by: this.hg_refer, promo_code: this.promo_code },
      };
      this.commercialService.updateResponses(Obj);
      this.router.navigateByUrl('/commercial/enrollment');
      // this.next();
    }
  }

  next() {
    // this.commercialService.messageService({ 'currentId': this.data });
  }
}
